/**
 * Constantes de test-ids centralizadas (módulo Mostrador alineado con Sage 200).
 */
export const TID = {
  // login
  loginUser: "login-username-input",
  loginPin: "login-pin-input",
  loginSubmit: "login-submit-button",
  loginUserCard: (id) => `login-user-card-${id}`,
  // header
  headerSage: "header-sage-status",
  headerChain: "header-chain-status",
  headerUser: "header-user-badge",
  headerLogout: "header-logout-button",
  navPos: "nav-pos",
  navCash: "nav-cash",
  navTickets: "nav-tickets",
  navReports: "nav-reports",
  navSettings: "nav-settings",
  navTouch: "nav-touch",
  // open cash
  openCashInput: "open-cash-input",
  openCashSubmit: "open-cash-submit",
  // Sage Mostrador toolbar
  sageBtnNew: "sage-btn-new",
  sageBtnDelete: "sage-btn-delete",
  sageBtnValidate: "sage-btn-validate",
  sageBtnRefresh: "sage-btn-refresh",
  sageBtnSearch: "sage-btn-search",
  sageBtnPrint: "sage-btn-print",
  sageBtnCustomer: "sage-btn-customer",
  sageBtnEuro: "sage-btn-euro",
  // Cabecera
  sageEjercicio: "sage-input-ejercicio",
  sageSerie: "sage-input-serie",
  sageNumero: "sage-input-numero",
  sageFecha: "sage-input-fecha",
  sageNumLineas: "sage-input-numlineas",
  sageCliente: "sage-input-cliente",
  sageFormaCobro: "sage-input-formacobro",
  sageImportePendiente: "sage-input-importependiente",
  sageImporteVenta: "sage-display-importeventa",
  sageCobrarBtn: "sage-btn-cobrar",
  sageFacturarBtn: "sage-btn-facturar",
  sageCambiarClienteBtn: "sage-btn-cambiar-cliente",
  sageAddProductBtn: "sage-btn-add-product",
  // Grid líneas
  sageLine: (id) => `sage-line-${id}`,
  sageLineDelete: (id) => `sage-line-delete-${id}`,
  sageLineQty: (id) => `sage-line-qty-${id}`,
  sageLineDto: (id) => `sage-line-dto-${id}`,
  // Tabs
  sageTabRight: (k) => `sage-tab-right-${k}`,
  sageTabBottom: (k) => `sage-tab-bottom-${k}`,
  // legacy POS táctil
  posSearch: "pos-search-input",
  posCategory: (id) => `pos-category-${id}`,
  posProduct: (id) => `pos-product-${id}`,
  posCart: "pos-cart-panel",
  posTotal: "pos-total",
  posPayBtn: "pos-pay-button",
  posParkBtn: "pos-park-button",
  posCancelBtn: "pos-cancel-button",
  posCustomerBtn: "pos-customer-button",
  // payment
  payModal: "payment-modal",
  payMethodCash: "payment-method-cash",
  payMethodCard: "payment-method-card",
  payMethodMixed: "payment-method-mixed",
  payAmount: "payment-amount-input",
  payConfirm: "payment-confirm-button",
  payClose: "payment-close-button",
  // ticket
  ticketModal: "ticket-modal",
  ticketClose: "ticket-close-button",
  ticketNew: "ticket-new-sale-button",
  // tickets list
  ticketsList: "tickets-list",
  ticketRow: (id) => `tickets-row-${id}`,
  ticketResume: (id) => `tickets-resume-${id}`,
  ticketView: (id) => `tickets-view-${id}`,
  ticketRefund: (id) => `tickets-refund-${id}`,
  // cash
  cashCloseBtn: "cash-close-button",
  cashCountedInput: "cash-counted-input",
  cashCloseConfirm: "cash-close-confirm",
  cashXReport: "cash-x-report",
  cashMoveIn: "cash-move-in",
  cashMoveOut: "cash-move-out",
};
